module.exports = __webpack_public_path__ + "img/Trophy.3039938f.svg";